import { Button } from '@mui/material';

const ActionButton = ({
  onClick,
  background,
  hoverBackground,
  icon,
  iconColor,
  border,
  extraStyles,
  width,
}) => (
  <Button
    onClick={onClick}
    sx={{
      background,
      width: width ?? '55px',
      maxWidth: '90px',
      height: '55px',
      borderRadius: '8px',
      color: iconColor,
      border,
      '&:hover': {
        boxShadow: '-1px 1px 6px 0 rgba(0,0,0,0.32)',
        background: hoverBackground,
      },
      ...extraStyles,
    }}
  >
    {icon}
  </Button>
);

export default ActionButton;
